import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ImageOff } from "lucide-react";

export default function AuthImage({ fileId, className = "", alt = "photo" }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!fileId) return;
    let revoke;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/files/${fileId}`, { responseType: "blob" });
        if (cancelled) return;
        const blob = URL.createObjectURL(data);
        revoke = blob;
        setUrl(blob);
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();
    return () => { cancelled = true; if (revoke) URL.revokeObjectURL(revoke); };
  }, [fileId]);

  if (!fileId) return (
    <div className={`flex items-center justify-center bg-slate-100 text-slate-300 ${className}`}>
      <ImageOff className="w-5 h-5" />
    </div>
  );
  if (failed) return (
    <div className={`flex items-center justify-center bg-slate-100 text-slate-400 ${className}`}>
      <ImageOff className="w-5 h-5" />
    </div>
  );
  if (!url) return <div className={`animate-pulse bg-slate-100 ${className}`} />;
  return <img src={url} alt={alt} className={className} data-testid="auth-image" />;
}
